// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// API de Moreka (moreka-tienda-dev): tienda, POS y admin comparten API.
export const environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyAzM87z-TV_WCYp-gDICblcFQj-_0UDxnE',
  apiUrl: 'https://c616noa35f.execute-api.us-east-1.amazonaws.com/dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
